// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__38RVb","errorWrapper":"styles_errorWrapper__GDwaC","close":"styles_close__CYPEh","description":"styles_description__2QoEh"};